import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import EditorDialogShell from 'src/common/components/modals/EditorDialogShell';
import { IEdition } from 'src/interfaces/Edition';
import EditionTotalsSummary from 'src/pages/Dashboard/Editions/components/EditionTotalsSummary';
import { hasEditionAccountingData } from 'src/pages/Dashboard/Editions/utils/editionAccounting';

type Props = {
  edition: IEdition;
  open: boolean;
  onClose: () => void;
};

const EditionTotalsModal = ({ edition, open, onClose }: Props) => {
  const { t } = useTranslation();
  const hasTotals = hasEditionAccountingData(edition);

  return (
    <EditorDialogShell
      id="edition-totals"
      open={open}
      onClose={onClose}
      title={`${t('editions.totals')} (${edition.year})`}
      maxWidth="sm"
    >
      {hasTotals && edition.checkinsByPrice != null ? (
        <EditionTotalsSummary
          checkinsByPrice={edition.checkinsByPrice}
          totalPrice={edition.totalPrice as number}
          editionPrices={edition}
          disableGutters
          emphasizeTotal
        />
      ) : (
        <Typography variant="body2" color="text.secondary">
          -
        </Typography>
      )}
    </EditorDialogShell>
  );
};

export default EditionTotalsModal;
